
<template>

    <div class="NumberInput">
        <div>

        <div class="DecreaseButton" @click="OnDecreaseButtonClick"
                @select="(e)=>{e.preventDefault();return false;}"
                @selectstart="(e)=>{e.preventDefault();return false;}"
                :style="{opacity:(m_Value==this.m_MinValue+''?'0.5':1)}"
             ><span style="position:relative;top:2px">━</span></div><input type="number"
               v-model="m_Value"
               v-on:input="OnValueInput"
               v-on:change="OnValueChange"
               v-on:blur="OnBlur"
               :class="CssClass"
               :readonly="ReadOnly"
               :DataType="DataType"
               :nullable="Nullable"
               :disabled="Enabled == false"
               :MaxLength="MaxLength"
               v-show="Visible"
               class="NumberField"
               ref="Element" /><div  class="IncreaseButton" @click="OnIncreaseButtonClick"
                                    @select="(e)=>{e.preventDefault();return false;}"
                                    @selectstart="(e)=>{e.preventDefault();return false;}"
                                    >✚</div>

        </div>
    </div>

</template>

<script>
    import Utility from '@/Common/Utility'

    export default {
        data() {
            return {
                m_Value: "",
                m_MinValue : 0 ,
                m_Attribute: {
                    Nullable: false,
                    Enabled: true,
                    Visible: true,
                    ReadOnly: false,
                    MaxLength: null,
                    AutoTrim: false
                }
            };
        }
        ,
        props: ["value", "nullable", "AutoTrim", "Attribute","MinValue"],


        computed: {

            CssClass: {

                get: function () {
                    let result = "";


                    if (this.Attribute != null && this.Attribute.CssClass != null) {
                        result = this.Attribute.CssClass;
                    }

                    return result;
                }
            }
            ,
            Nullable: function () {
                if (this.m_Attribute.Nullable == null) {
                    this.m_Attribute.Nullable = false;
                }

                return this.m_Attribute.Nullable + "";
            }
            ,

            ReadOnly: {

                get: function () {
                    let result = false;

                    if (this.m_Attribute != null && this.m_Attribute.ReadOnly != null) {
                        result = this.m_Attribute.ReadOnly;
                    }

                    return result;
                },
                set: function (val) {
                    alert("set val=" + val);
                }

            }
            ,
            Enabled: {

                get: function () {
                    let result = true;

                    if (this.m_Attribute != null && this.m_Attribute.Enabled != null) {
                        result = this.m_Attribute.Enabled;
                    }

                    return result;
                }
            }
            ,
            Disabled: {

                get: function () {
                    let result = false;


                    if (this.m_Attribute.Enabled != null) {
                        result = !this.m_Attribute.Enabled;
                    }

                    return result;
                },
                set: function (val) {
                    alert("set val=" + val);
                }

            }
            ,
            Visible: {

                get: function () {
                    let result = true;


                    if (this.m_Attribute.Visible != null) {
                        result = this.m_Attribute.Visible;
                    }

                    return result;
                }
            },

            DataType: {

                get: function () {
                    let result = "text";

                    if (this.m_Attribute != null && this.m_Attribute.DataType != null) {
                        result = this.m_Attribute.DataType;
                    }

                    return result;
                }
            },

            MaxLength: {

                get: function () {
                    let result = "128";

                    if (this.m_Attribute != null && this.m_Attribute.MaxLength != null) {
                        result = this.m_Attribute.MaxLength;
                    }

                    return result;
                }
            }

        }
        ,

        methods: {

            OnBlur(e) {
                let trimValue = "";


                if (this.AutoTrim == "true") {

                    trimValue = e.target.value.trim();
                    e.target.value = trimValue;
                    this.$emit("input", trimValue);

                }


                this.$emit("blur");

            },


            OnValueInput(e) {
                if (this.$refs.Element.nextSibling != null) {
                    if (this.$refs.Element.nextSibling.nodeType == 1) {
                        if (this.$refs.Element.nextSibling.classList.contains("error_message")) {
                            this.$refs.Element.nextSibling.innerHTML = "";
                        }
                    }
                }

                

                this.$emit("input", e.target.value);
            },

            OnValueChange(e) {
                let needEmitInput = false;

                if (this.$refs.Element.nextSibling != null) {
                    if (this.$refs.Element.nextSibling.nodeType == 1) {
                        if (this.$refs.Element.nextSibling.classList.contains("error_message")) {
                            this.$refs.Element.nextSibling.innerHTML = "";
                        }
                    }
                }

                if (this.m_Value == null || this.m_Value == "") {
                    this.m_Value = this.m_MinValue;
                    needEmitInput = true;
                }
                else if (isNaN(this.m_MinValue)) {
                    this.m_Value = this.m_MinValue;
                    needEmitInput = true;
                }
                else if (parseInt(this.m_Value) < this.m_MinValue) {
                    this.m_Value = this.m_MinValue;
                    needEmitInput = true;
                }

                if (needEmitInput) {
                    this.$emit("input", this.m_Value);
                }
                 
                this.$emit("change", this.m_Value);
            },

            UpdateElementByAttribute() {

            },

            OnButtonClick() {
                alert("Enabled = " + this.m_Attribute.Enabled);
            },


            OnDecreaseButtonClick() {
                if (parseInt(this.m_Value + "") > this.m_MinValue) {
                    this.m_Value = parseInt(this.m_Value + "") - 1;

                    this.$emit("input", this.m_Value);
                    this.$emit("change", this.m_Value );
                }
            },

            OnIncreaseButtonClick() {
                this.m_Value = parseInt(this.m_Value + "") + 1;

 
                this.$emit("input", this.m_Value);
                this.$emit("change", this.m_Value );
            },

        },

        created() {

            if (this.nullable == "false" || this.nullable == false) {
                this.m_Attribute.Nullable = false;
            }
            else {
                this.m_Attribute.Nullable = true;
            }

            if (this.value == null) {
                this.m_Value = "";
            }
            else {
                this.m_Value = this.value;
            }

            if (this.Attribute != null) {
                Utility.SetNotNullAttributes(this, this.m_Attribute, this.Attribute);
            }

            if (this.MinValue != null) {
                this.m_MinValue = parseInt(this.MinValue + "");
            }
        },

        watch: {
            Attribute: function (newVal, oldVal) {
                Utility.SetNotNullAttributes(this, this.m_Attribute, newVal);
            },

            nullable: function (newVal, oldVal) {
                this.m_Attribute.Nullable = newVal;
            },

            value: function (newVal, oldVal) {

                if (newVal == null) {
                    this.m_Value = "";
                }
                else {
                    this.m_Value = newVal;
                }
            }
        }


    }
</script>

<style scoped>
    .NumberInput
    {
        display:inline-block;
        vertical-align:top;
        white-space:nowrap;
    }

    .NumberInput  > div{
        display:flex;
        flex-wrap:nowrap;
        flex-direction:row;
        align-content:center;
        justify-content:space-between;
 
        width:100%;
    }

    .NumberField::-webkit-outer-spin-button,
    .NumberField::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    .DecreaseButton, .IncreaseButton {
        display: block;
        text-align: center;
        font-size: 18px;
        flex-basis: 28px;
        min-width:28px;
        flex-grow:0;
        line-height: 25px;
        height: 28px;
        border: 1px solid #b0b0b0;
        box-sizing: border-box;
        cursor:pointer;
    }

        .DecreaseButton:hover, .IncreaseButton:hover
        {
            background-color:#f0f0f0;
        }

    .DecreaseButton {
        border-bottom-left-radius: 4px;
        border-top-left-radius: 4px;
        left: 1px;
        display: block;
    }

    .NumberField {
        line-height: 25px;
        height:28px;
        width:90%;
        flex-basis:90%;
        flex-grow:0;
        display: inline-block;
        border: none;
        text-align: center;
        border-top: 1px solid #c0c0c0;
        border-bottom: 1px solid #c0c0c0;
        box-sizing:border-box;
    }

    .IncreaseButton {
        border-bottom-right-radius: 4px;
        border-top-right-radius: 4px;
        display: block;
        position: relative;
        left: -2px;
    }
</style>
